import { centsToDollars } from '@common/paymentsUtils/currencyUtils';
import { formatTimestampToYMDString } from '@common/paymentsUtils/dateUtils';
import type { IRentalProtectionPolicyModel, IRentalProtectionPolicyNumericModel } from '@rental-manager/models/Types';

export default (rentalProtectionPolicy: IRentalProtectionPolicyNumericModel): IRentalProtectionPolicyModel => {
  const { policyId, policyEffectiveDate, coverageRequestSigned, premium, policyStatus } = rentalProtectionPolicy;
  return {
    policyId: policyId && String(policyId),
    policyEffectiveDate: policyEffectiveDate && formatTimestampToYMDString(policyEffectiveDate),
    coverageRequestSigned: coverageRequestSigned && Boolean(coverageRequestSigned),
    premium: premium && centsToDollars(premium),
    policyStatus: policyStatus && String(policyStatus),
  };
};
